export { default as Img200 } from './processed/200/InBetween.jpg';
export { default as Img400 } from './processed/400/InBetween.jpg';
export { default as Imgthumb } from './processed/thumb/InBetween.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/InBetween.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/InBetween.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      36,
      134,
      219
    ],
    "_population": 0
  },
  "DarkVibrant": {
    "_rgb": [
      18,
      68,
      111
    ],
    "_population": 197,
    "_hsl": [
      0.5770609318996416,
      0.7209302325581396,
      0.2529411764705882
    ]
  },
  "Muted": {
    "_rgb": [
      153,
      96,
      113
    ],
    "_population": 6,
    "_hsl": [
      0.9502923976608187,
      0.2289156626506024,
      0.48823529411764705
    ]
  },
  "LightMuted": {
    "_rgb": [
      228,
      224,
      212
    ],
    "_population": 3892,
    "_hsl": [
      0.12499999999999985,
      0.22857142857142854,
      0.8627450980392157
    ]
  },
  "DarkMuted": {
    "_rgb": [
      60,
      88,
      110
    ],
    "_population": 3926,
    "_hsl": [
      0.5733333333333334,
      0.29411764705882354,
      0.33333333333333337
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/InBetween.js